import { Box } from '@lifeomic/chroma-react/components/Box';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useLexicalEditable } from '@lexical/react/useLexicalEditable';
import { $getNodeByKey } from 'lexical';
import React from 'react';
import { InlineAttachment } from '../../../../Attachments/InlineAttachment';
import { KnowledgeBaseCitationInline } from '../../../../Attachments/KnowledgeBaseCitationInline';
import { parseKnowledgeBaseCitation } from '../../../../../../../../util/knowledgeBaseCitation';
import { useMaybeImpressionEditorContext } from '../../../Context';

type AttachmentProps = {
  footnoteId: string;
  nodeKey: string;
};

export const Attachment = ({ footnoteId, nodeKey }: AttachmentProps) => {
  const impressionEditor = useMaybeImpressionEditorContext();
  const [editor] = useLexicalComposerContext();
  const lexicalEditable = useLexicalEditable();

  const handleDelete = () => {
    editor.update(() => {
      const node = $getNodeByKey(nodeKey);
      if (node) {
        node.remove();
      }
    });
  };

  if (impressionEditor === undefined) {
    const kb = parseKnowledgeBaseCitation(footnoteId);
    if (kb) {
      return (
        <Box direction="row" marginTop={2}>
          <KnowledgeBaseCitationInline citation={kb} />
        </Box>
      );
    }
    return (
      <span style={{ verticalAlign: 'super', fontSize: '0.85em' }}>
        [{footnoteId.length > 48 ? `${footnoteId.slice(0, 45)}…` : footnoteId}]
      </span>
    );
  }

  if (!impressionEditor.activeImpression) {
    return null;
  }

  const { isEditing, viewMode, patient, activeImpression } = impressionEditor;
  const effectiveIsEditing = isEditing && lexicalEditable;

  return (
    <InlineAttachment
      footnoteId={footnoteId}
      onDelete={handleDelete}
      viewMode={viewMode}
      isEditing={effectiveIsEditing}
      patient={patient}
      impression={activeImpression}
      renderKnowledgeBaseCitations={
        impressionEditor.renderKnowledgeBaseCitations
      }
      text={''}
    />
  );
};
